import type { PaymentProgress } from '../types';

// ENG-5549: whether Stripe has already confirmed a card for this signup (or the signup
// itself went through), so the payment step must retry without the card form. A newer
// SetupIntent only brings the card form back while the signup has not gone through.
export function hasCardOnFile(progress: PaymentProgress, clientSecret: string | null): boolean {
  return (
    !!progress.signupResult || (!!clientSecret && progress.confirmedClientSecret === clientSecret)
  );
}
